

export const commonBase = {
  "color_base_black": "#000000",
  "color_base_black_1": "#F8F8F8",
  "color_base_black_10": "#B5B5B6",
  "color_base_black_11": "#909092",
  "color_base_black_12": "#6B6B6F",
  "color_base_black_13": "#222226",
  "color_base_black_14": "#2B2B2F",
  "color_base_black_15": "#19191E",
  "color_base_black_16": "#26262C",
  "color_base_black_18_a5": "#0000000D",
  "color_base_black_18_a50": "#00000080",
  "color_base_black_18_a70": "#000000B3",
  "color_base_black_18_a85": "#000000D9",
  "color_base_black_19_a20": "#00000033",
  "color_base_black_2": "#F0F0F0",
  "color_base_black_20_a20": "#E6E6E633",
  "color_base_black_21": "#190908",
  "color_base_black_22": "#050B19",
  "color_base_black_26_a60": "#D8D8D899",
  "color_base_black_3": "#EAEAEA",
  "color_base_black_4": "#E0E0E0",
  "color_base_black_5": "#C6C6C6",
  "color_base_black_6": "#9C9C9C",
  "color_base_black_7": "#666666",
  "color_base_black_8": "#222222",
  "color_base_black_9": "#E6E6E6",
  "color_base_blue_1": "#E6F7FF",
  "color_base_blue_10": "#002766",
  "color_base_blue_11": "#6EAFCC",
  "color_base_blue_12": "#004182",
  "color_base_blue_13": "#3D3D42",
  "color_base_blue_14": "#333337",
  "color_base_blue_15": "#385080",
  "color_base_blue_16": "#326BFB",
  "color_base_blue_17": "#618EFF",
  "color_base_blue_18": "#667BA3",
  "color_base_blue_19_a50": "#38508080",
  "color_base_blue_2": "#BAE7FF",
  "color_base_blue_20_a50": "#667BA380",
  "color_base_blue_21_a4": "#2222260A",
  "color_base_blue_21_a50": "#22222680",
  "color_base_blue_23": "#779EFE",
  "color_base_blue_24": "#5F82D9",
  "color_base_blue_25": "#ADB1C6",
  "color_base_blue_26": "#292C31",
  "color_base_blue_27_a50": "#2B2B2F80",
  "color_base_blue_28_a90": "#B5B5B6E6",
  "color_base_blue_3": "#91D5FF",
  "color_base_blue_4": "#69C0FF",
  "color_base_blue_5": "#40A9FF",
  "color_base_blue_6": "#168FFF",
  "color_base_blue_7": "#096DD9",
  "color_base_blue_8": "#0050B3",
  "color_base_blue_9": "#003A8C",
  "color_base_cyan_1": "#EDFFF7",
  "color_base_cyan_10": "#003028",
  "color_base_cyan_11": "#17C5A2",
  "color_base_cyan_12": "#108CEC",
  "color_base_cyan_13": "#112233",
  "color_base_cyan_2": "#C2FCE3",
  "color_base_cyan_3": "#92F0CA",
  "color_base_cyan_4": "#66E3B5",
  "color_base_cyan_5": "#3ED6A4",
  "color_base_cyan_6": "#36CFA2",
  "color_base_cyan_7": "#0EA37B",
  "color_base_cyan_8": "#047D61",
  "color_base_cyan_9": "#005745",
  "color_base_gold_1": "#FFFBE6",
  "color_base_gold_10": "#633501",
  "color_base_gold_2": "#FFF0B5",
  "color_base_gold_3": "#FFE48C",
  "color_base_gold_4": "#FFD663",
  "color_base_gold_5": "#FFC438",
  "color_base_gold_6": "#FDAF12",
  "color_base_gold_7": "#D58905",
  "color_base_gold_8": "#B06A00",
  "color_base_gold_9": "#8A4E00",
  "color_base_green_1": "#E4F9E1",
  "color_base_green_10": "#002004",
  "color_base_green_11": "#10CC00",
  "color_base_green_12": "#4BD389",
  "color_base_green_13": "#2DC5A6",
  "color_base_green_14": "#76D679",
  "color_base_green_15": "#64B566",
  "color_base_green_2": "#ADEDA1",
  "color_base_green_3": "#81E075",
  "color_base_green_4": "#57D44C",
  "color_base_green_5": "#2FC727",
  "color_base_green_6": "#09BA08",
  "color_base_green_7": "#009401",
  "color_base_green_8": "#016E04",
  "color_base_green_9": "#004706",
  "color_base_magenta_1": "#FFF0F6",
  "color_base_magenta_10": "#52023A",
  "color_base_magenta_2": "#FFD4E6",
  "color_base_magenta_3": "#FFABD1",
  "color_base_magenta_4": "#FF82BF",
  "color_base_magenta_5": "#F757AA",
  "color_base_magenta_6": "#EA2D95",
  "color_base_magenta_7": "#C41B7E",
  "color_base_magenta_8": "#9E0D66",
  "color_base_magenta_9": "#780550",
  "color_base_orange_1": "#FFF2E6",
  "color_base_orange_10": "#661300",
  "color_base_orange_11": "#FF5814",
  "color_base_orange_12": "#FF5F14",
  "color_base_orange_13": "#FF5000",
  "color_base_orange_14": "#FF8652",
  "color_base_orange_15": "#FFA061",
  "color_base_orange_16": "#DB8B56",
  "color_base_orange_2": "#FFCDA3",
  "color_base_orange_3": "#FFB27A",
  "color_base_orange_4": "#FF9452",
  "color_base_orange_5": "#FF7429",
  "color_base_orange_6": "#FF4906",
  "color_base_orange_7": "#D93D00",
  "color_base_orange_8": "#B32D00",
  "color_base_orange_9": "#8C1E00",
  "color_base_purple_1": "#F9F0FF",
  "color_base_purple_10": "#13023B",
  "color_base_purple_2": "#EED9FF",
  "color_base_purple_3": "#D4ACFA",
  "color_base_purple_4": "#B47EED",
  "color_base_purple_5": "#9353E0",
  "color_base_purple_6": "#722DD3",
  "color_base_purple_7": "#541CAD",
  "color_base_purple_8": "#380F87",
  "color_base_purple_9": "#230661",
  "color_base_red_1": "#FFF3F0",
  "color_base_red_10": "#66030B",
  "color_base_red_11": "#F73B68",
  "color_base_red_12": "#FB5858",
  "color_base_red_14": "#FF8048",
  "color_base_red_15": "#FE3666",
  "color_base_red_16": "#FE5E84",
  "color_base_red_17": "#F73B68",
  "color_base_red_17_a80": "#F73B68CC",
  "color_base_red_18": "#F86286",
  "color_base_red_19_a50": "#FE366680",
  "color_base_red_2": "#FFDCD4",
  "color_base_red_20_a50": "#F73B6880",
  "color_base_red_21_a30": "#FE36664D",
  "color_base_red_22_a70": "#FE3666B3",
  "color_base_red_23_a10": "#FE36661A",
  "color_base_red_24": "#FFF2EC",
  "color_base_red_25": "#3B2824",
  "color_base_red_26": "#FF6048",
  "color_base_red_27": "#F86850",
  "color_base_red_28": "#351F28",
  "color_base_red_29": "#FF5D52",
  "color_base_red_3": "#FFB7AB",
  "color_base_red_30": "#FF6B80",
  "color_base_red_31": "#E56577",
  "color_base_red_4": "#FF9182",
  "color_base_red_5": "#FF6759",
  "color_base_red_6": "#FE3666",
  "color_base_red_7": "#D9211E",
  "color_base_red_8": "#B31013",
  "color_base_red_9": "#8C060C",
  "color_base_verdancy_1": "#FCFFE6",
  "color_base_verdancy_10": "#324B10",
  "color_base_verdancy_2": "#F5FFBA",
  "color_base_verdancy_3": "#EBFF91",
  "color_base_verdancy_4": "#D3F264",
  "color_base_verdancy_5": "#BAE639",
  "color_base_verdancy_6": "#A1DA14",
  "color_base_verdancy_7": "#7CB307",
  "color_base_verdancy_8": "#659317",
  "color_base_verdancy_9": "#3F6600",
  "color_base_violet_1": "#F0F5FF",
  "color_base_violet_10": "#030852",
  "color_base_violet_11": "#A189FE",
  "color_base_violet_12": "#8873D9",
  "color_base_violet_2": "#D6E4FF",
  "color_base_violet_3": "#ADC6FF",
  "color_base_violet_4": "#85A5FF",
  "color_base_violet_5": "#597EF7",
  "color_base_violet_6": "#2E53EB",
  "color_base_violet_7": "#1D39C4",
  "color_base_violet_8": "#10239E",
  "color_base_violet_9": "#061178",
  "color_base_white": "#FFFFFF",
  "color_base_white_2_a10": "#FFFFFF1A",
  "color_base_white_2_a13": "#FFFFFF21",
  "color_base_white_2_a50": "#FFFFFF80",
  "color_base_white_3_a20": "#FFFFFF33",
  "color_base_white_4_a8": "#FFFFFF14",
  "color_base_white_5_a60": "#FFFFFF99",
  "color_base_white_6_a75": "#FFFFFFBF",
  "color_base_white_7_a85": "#FFFFFFD9",
  "color_base_white_8_a40": "#EAEAEA66",
  "color_base_yellow_1": "#FEFFE6",
  "color_base_yellow_10": "#614700",
  "color_base_yellow_11": "#FFF122",
  "color_base_yellow_12": "#FFF128",
  "color_base_yellow_2": "#FFFFB5",
  "color_base_yellow_3": "#FFFB8C",
  "color_base_yellow_4": "#FFF563",
  "color_base_yellow_5": "#FFEB3B",
  "color_base_yellow_6": "#FADB14",
  "color_base_yellow_7": "#D4B106",
  "color_base_yellow_8": "#AD8B00",
  "color_base_yellow_9": "#876800"
}

export const colorScene = {
  "cs_common_background__divider_primarydark": "var(--cs_common_background__divider_primarydark)",
  "cs_common_background__divider_secondarydark": "var(--cs_common_background__divider_secondarydark)",
  "cs_common_background__navigation_primary": "var(--cs_common_background__navigation_primary)",
  "cs_common_background_action_selected": "var(--cs_common_background_action_selected)",
  "cs_common_background_alert_seperator": "var(--cs_common_background_alert_seperator)",
  "cs_common_background_alet_list_seperator": "var(--cs_common_background_alet_list_seperator)",
  "cs_common_background_badge": "var(--cs_common_background_badge)",
  "cs_common_background_black": "var(--cs_common_background_black)",
  "cs_common_background_bubble": "var(--cs_common_background_bubble)",
  "cs_common_background_bubble_primary": "var(--cs_common_background_bubble_primary)",
  "cs_common_background_bubble_shadow": "var(--cs_common_background_bubble_shadow)",
  "cs_common_background_butpress": "var(--cs_common_background_butpress)",
  "cs_common_background_clear": "var(--cs_common_background_clear)",
  "cs_common_background_dialog": "var(--cs_common_background_dialog)",
  "cs_common_background_dialog_primary": "var(--cs_common_background_dialog_primary)",
  "cs_common_background_dialog_secondary": "var(--cs_common_background_dialog_secondary)",
  "cs_common_background_divider_primary": "var(--cs_common_background_divider_primary)",
  "cs_common_background_divider_secondary": "var(--cs_common_background_divider_secondary)",
  "cs_common_background_float_primary": "var(--cs_common_background_float_primary)",
  "cs_common_background_float_primarydark": "var(--cs_common_background_float_primarydark)",
  "cs_common_background_gradient_start": "var(--cs_common_background_gradient_start)",
  "cs_common_background_gravitybtn": "var(--cs_common_background_gravitybtn)",
  "cs_common_background_gray": "var(--cs_common_background_gray)",
  "cs_common_background_graydark": "var(--cs_common_background_graydark)",
  "cs_common_background_green": "var(--cs_common_background_green)",
  "cs_common_background_hintsafety": "var(--cs_common_background_hintsafety)",
  "cs_common_background_label_bg2": "var(--cs_common_background_label_bg2)",
  "cs_common_background_label1dark": "var(--cs_common_background_label1dark)",
  "cs_common_background_labelbackgroundcolor": "var(--cs_common_background_labelbackgroundcolor)",
  "cs_common_background_labelbackgroundcolordark": "var(--cs_common_background_labelbackgroundcolordark)",
  "cs_common_background_labelone": "var(--cs_common_background_labelone)",
  "cs_common_background_lable2dark": "var(--cs_common_background_lable2dark)",
  "cs_common_background_lable4dark": "var(--cs_common_background_lable4dark)",
  "cs_common_background_lablefour": "var(--cs_common_background_lablefour)",
  "cs_common_background_lablethree": "var(--cs_common_background_lablethree)",
  "cs_common_background_labletwo": "var(--cs_common_background_labletwo)",
  "cs_common_background_least": "var(--cs_common_background_least)",
  "cs_common_background_lightgreydark": "var(--cs_common_background_lightgreydark)",
  "cs_common_background_line": "var(--cs_common_background_line)",
  "cs_common_background_loading_secondary": "var(--cs_common_background_loading_secondary)",
  "cs_common_background_main": "var(--cs_common_background_main)",
  "cs_common_background_maindark": "var(--cs_common_background_maindark)",
  "cs_common_background_mainlight": "var(--cs_common_background_mainlight)",
  "cs_common_background_masking": "var(--cs_common_background_masking)",
  "cs_common_background_maskingdark": "var(--cs_common_background_maskingdark)",
  "cs_common_background_message": "var(--cs_common_background_message)",
  "cs_common_background_navigation_primary": "var(--cs_common_background_navigation_primary)",
  "cs_common_background_normal_indicator": "var(--cs_common_background_normal_indicator)",
  "cs_common_background_orange": "var(--cs_common_background_orange)",
  "cs_common_background_orange1": "var(--cs_common_background_orange1)",
  "cs_common_background_placeholder": "var(--cs_common_background_placeholder)",
  "cs_common_background_placeholder_deep": "var(--cs_common_background_placeholder_deep)",
  "cs_common_background_placeholder_deepdark": "var(--cs_common_background_placeholder_deepdark)",
  "cs_common_background_placeholderdark": "var(--cs_common_background_placeholderdark)",
  "cs_common_background_primary": "var(--cs_common_background_primary)",
  "cs_common_background_primarydark": "var(--cs_common_background_primarydark)",
  "cs_common_background_process_bg": "var(--cs_common_background_process_bg)",
  "cs_common_background_red": "var(--cs_common_background_red)",
  "cs_common_background_red_error": "var(--cs_common_background_red_error)",
  "cs_common_background_reddark": "var(--cs_common_background_reddark)",
  "cs_common_background_round_destructive": "var(--cs_common_background_round_destructive)",
  "cs_common_background_safetydark": "var(--cs_common_background_safetydark)",
  "cs_common_background_safetylight": "var(--cs_common_background_safetylight)",
  "cs_common_background_secondary": "var(--cs_common_background_secondary)",
  "cs_common_background_selected_index": "var(--cs_common_background_selected_index)",
  "cs_common_background_seperator": "var(--cs_common_background_seperator)",
  "cs_common_background_shallowblack": "var(--cs_common_background_shallowblack)",
  "cs_common_background_shallowblackdark": "var(--cs_common_background_shallowblackdark)",
  "cs_common_background_shallowgray": "var(--cs_common_background_shallowgray)",
  "cs_common_background_shallowgraydark": "var(--cs_common_background_shallowgraydark)",
  "cs_common_background_surface_primary": "var(--cs_common_background_surface_primary)",
  "cs_common_background_surface_primarydark": "var(--cs_common_background_surface_primarydark)",
  "cs_common_background_surface_secondary": "var(--cs_common_background_surface_secondary)",
  "cs_common_background_switch": "var(--cs_common_background_switch)",
  "cs_common_background_switchdark": "var(--cs_common_background_switchdark)",
  "cs_common_background_tab": "var(--cs_common_background_tab)",
  "cs_common_background_tertiary": "var(--cs_common_background_tertiary)",
  "cs_common_background_toast": "var(--cs_common_background_toast)",
  "cs_common_background_toastdark": "var(--cs_common_background_toastdark)",
  "cs_common_background_underline": "var(--cs_common_background_underline)",
  "cs_common_background_whitelight": "var(--cs_common_background_whitelight)",
  "cs_common_stroke_cccc": "var(--cs_common_stroke_cccc)",
  "cs_common_stroke_clear": "var(--cs_common_stroke_clear)",
  "cs_common_stroke_dialogline": "var(--cs_common_stroke_dialogline)",
  "cs_common_stroke_dialoglinedark": "var(--cs_common_stroke_dialoglinedark)",
  "cs_common_stroke_green": "var(--cs_common_stroke_green)",
  "cs_common_stroke_indicator": "var(--cs_common_stroke_indicator)",
  "cs_common_stroke_link": "var(--cs_common_stroke_link)",
  "cs_common_stroke_linkdark": "var(--cs_common_stroke_linkdark)",
  "cs_common_stroke_main": "var(--cs_common_stroke_main)",
  "cs_common_stroke_maindark": "var(--cs_common_stroke_maindark)",
  "cs_common_stroke_orange": "var(--cs_common_stroke_orange)",
  "cs_common_stroke_primary": "var(--cs_common_stroke_primary)",
  "cs_common_stroke_primary_2": "var(--cs_common_stroke_primary_2)",
  "cs_common_stroke_primary_2dark": "var(--cs_common_stroke_primary_2dark)",
  "cs_common_stroke_primary_3": "var(--cs_common_stroke_primary_3)",
  "cs_common_stroke_primary_3dark": "var(--cs_common_stroke_primary_3dark)",
  "cs_common_stroke_primary_4": "var(--cs_common_stroke_primary_4)",
  "cs_common_stroke_primary_4dark": "var(--cs_common_stroke_primary_4dark)",
  "cs_common_stroke_primary_5": "var(--cs_common_stroke_primary_5)",
  "cs_common_stroke_primary_5dark": "var(--cs_common_stroke_primary_5dark)",
  "cs_common_stroke_primarydark": "var(--cs_common_stroke_primarydark)",
  "cs_common_stroke_red_error": "var(--cs_common_stroke_red_error)",
  "cs_common_stroke_redadrk": "var(--cs_common_stroke_redadrk)",
  "cs_common_stroke_secondary": "var(--cs_common_stroke_secondary)",
  "cs_common_stroke_secondary1": "var(--cs_common_stroke_secondary1)",
  "cs_common_stroke_secondary1dark": "var(--cs_common_stroke_secondary1dark)",
  "cs_common_stroke_secondary2": "var(--cs_common_stroke_secondary2)",
  "cs_common_stroke_secondary2dark": "var(--cs_common_stroke_secondary2dark)",
  "cs_common_stroke_secondary3": "var(--cs_common_stroke_secondary3)",
  "cs_common_stroke_secondary3dark": "var(--cs_common_stroke_secondary3dark)",
  "cs_common_stroke_selectcard": "var(--cs_common_stroke_selectcard)",
  "cs_common_stroke_seperator": "var(--cs_common_stroke_seperator)",
  "cs_common_stroke_white": "var(--cs_common_stroke_white)",
  "cs_common_text_black": "var(--cs_common_text_black)",
  "cs_common_text_bubble": "var(--cs_common_text_bubble)",
  "cs_common_text_bubbleprimary": "var(--cs_common_text_bubbleprimary)",
  "cs_common_text_button": "var(--cs_common_text_button)",
  "cs_common_text_clear": "var(--cs_common_text_clear)",
  "cs_common_text_dialog_primary": "var(--cs_common_text_dialog_primary)",
  "cs_common_text_dialog_secondary": "var(--cs_common_text_dialog_secondary)",
  "cs_common_text_dialog_text1": "var(--cs_common_text_dialog_text1)",
  "cs_common_text_dialog_text2": "var(--cs_common_text_dialog_text2)",
  "cs_common_text_dialog_text3": "var(--cs_common_text_dialog_text3)",
  "cs_common_text_green": "var(--cs_common_text_green)",
  "cs_common_text_hintsafety": "var(--cs_common_text_hintsafety)",
  "cs_common_text_hintsafetydark": "var(--cs_common_text_hintsafetydark)",
  "cs_common_text_least": "var(--cs_common_text_least)",
  "cs_common_text_leastdark": "var(--cs_common_text_leastdark)",
  "cs_common_text_link": "var(--cs_common_text_link)",
  "cs_common_text_linkdark": "var(--cs_common_text_linkdark)",
  "cs_common_text_linkpress": "var(--cs_common_text_linkpress)",
  "cs_common_text_linkpressdark": "var(--cs_common_text_linkpressdark)",
  "cs_common_text_main": "var(--cs_common_text_main)",
  "cs_common_text_mainbutton": "var(--cs_common_text_mainbutton)",
  "cs_common_text_mainbuttondark": "var(--cs_common_text_mainbuttondark)",
  "cs_common_text_maindark": "var(--cs_common_text_maindark)",
  "cs_common_text_mainlight": "var(--cs_common_text_mainlight)",
  "cs_common_text_orange": "var(--cs_common_text_orange)",
  "cs_common_text_orange1": "var(--cs_common_text_orange1)",
  "cs_common_text_primary": "var(--cs_common_text_primary)",
  "cs_common_text_primarydark": "var(--cs_common_text_primarydark)",
  "cs_common_text_red": "var(--cs_common_text_red)",
  "cs_common_text_red_error": "var(--cs_common_text_red_error)",
  "cs_common_text_reddark": "var(--cs_common_text_reddark)",
  "cs_common_text_secondary": "var(--cs_common_text_secondary)",
  "cs_common_text_secondarydark": "var(--cs_common_text_secondarydark)",
  "cs_common_text_shallowblack": "var(--cs_common_text_shallowblack)",
  "cs_common_text_shallowdark": "var(--cs_common_text_shallowdark)",
  "cs_common_text_shallowgrey": "var(--cs_common_text_shallowgrey)",
  "cs_common_text_shallowwhite": "var(--cs_common_text_shallowwhite)",
  "cs_common_text_tab_normal": "var(--cs_common_text_tab_normal)",
  "cs_common_text_title": "var(--cs_common_text_title)",
  "cs_common_text_titledark": "var(--cs_common_text_titledark)",
  "cs_common_text_white": "var(--cs_common_text_white)",
  "cs_common_text_whitedark": "var(--cs_common_text_whitedark)",
  "cs_common_text_whitelight": "var(--cs_common_text_whitelight)",
  "cs_common_tint_allblack": "var(--cs_common_tint_allblack)",
  "cs_common_tint_black": "var(--cs_common_tint_black)",
  "cs_common_tint_blackdark": "var(--cs_common_tint_blackdark)",
  "cs_common_tint_blue": "var(--cs_common_tint_blue)",
  "cs_common_tint_bluedark": "var(--cs_common_tint_bluedark)",
  "cs_common_tint_darkgrey": "var(--cs_common_tint_darkgrey)",
  "cs_common_tint_darkgreydark": "var(--cs_common_tint_darkgreydark)",
  "cs_common_tint_green": "var(--cs_common_tint_green)",
  "cs_common_tint_grey": "var(--cs_common_tint_grey)",
  "cs_common_tint_greydark": "var(--cs_common_tint_greydark)",
  "cs_common_tint_hintsafety": "var(--cs_common_tint_hintsafety)",
  "cs_common_tint_lightgrey": "var(--cs_common_tint_lightgrey)",
  "cs_common_tint_lightgreydark": "var(--cs_common_tint_lightgreydark)",
  "cs_common_tint_link": "var(--cs_common_tint_link)",
  "cs_common_tint_linkdark": "var(--cs_common_tint_linkdark)",
  "cs_common_tint_main": "var(--cs_common_tint_main)",
  "cs_common_tint_maindark": "var(--cs_common_tint_maindark)",
  "cs_common_tint_orange": "var(--cs_common_tint_orange)",
  "cs_common_tint_orange1": "var(--cs_common_tint_orange1)",
  "cs_common_tint_red": "var(--cs_common_tint_red)",
  "cs_common_tint_red_error": "var(--cs_common_tint_red_error)",
  "cs_common_tint_reddark": "var(--cs_common_tint_reddark)",
  "cs_common_tint_searchicon": "var(--cs_common_tint_searchicon)",
  "cs_common_tint_vajrablue": "var(--cs_common_tint_vajrablue)",
  "cs_common_tint_vajragreen": "var(--cs_common_tint_vajragreen)",
  "cs_common_tint_vajraorange": "var(--cs_common_tint_vajraorange)",
  "cs_common_tint_vajrared": "var(--cs_common_tint_vajrared)",
  "cs_common_tint_vajraviolet": "var(--cs_common_tint_vajraviolet)",
  "cs_common_tint_white": "var(--cs_common_tint_white)",
  "cs_common_tint_whitedark": "var(--cs_common_tint_whitedark)"
}

export const colorSceneLight = {
  "cs_common_background__divider_primarydark": "#222226",
  "cs_common_background__divider_secondarydark": "#2B2B2F",
  "cs_common_background__navigation_primary": "#222226",
  "cs_common_background_action_selected": "#F8F8F8",
  "cs_common_background_alert_seperator": "#E0E0E0",
  "cs_common_background_alet_list_seperator": "rgba(255,255,255,0.039)",
  "cs_common_background_badge": "#FE5E84",
  "cs_common_background_black": "#000000",
  "cs_common_background_bubble": "rgba(0,0,0,0.70)",
  "cs_common_background_bubble_primary": "rgba(0,0,0,0.70)",
  "cs_common_background_bubble_shadow": "#000000",
  "cs_common_background_butpress": "rgba(254,54,102,0.50)",
  "cs_common_background_clear": "rgba(0,0,0,0.0)",
  "cs_common_background_dialog": "#FFFFFF",
  "cs_common_background_dialog_primary": "#222222",
  "cs_common_background_dialog_secondary": "#666666",
  "cs_common_background_divider_primary": "#E0E0E0",
  "cs_common_background_divider_secondary": "#EAEAEA",
  "cs_common_background_float_primary": "#FFFFFF",
  "cs_common_background_float_primarydark": "#2B2B2F",
  "cs_common_background_gradient_start": "#FF4906",
  "cs_common_background_gravitybtn": "#FF6048",
  "cs_common_background_gray": "#666666",
  "cs_common_background_graydark": "#B5B5B6",
  "cs_common_background_green": "#17C5A2",
  "cs_common_background_hintsafety": "#326BFB",
  "cs_common_background_label_bg2": "#FFF4F0",
  "cs_common_background_label1dark": "#2B2B2F",
  "cs_common_background_labelbackgroundcolor": "#FFF2EC",
  "cs_common_background_labelbackgroundcolordark": "#3B2824",
  "cs_common_background_labelone": "#EFEFEF",
  "cs_common_background_lable2dark": "#351F28",
  "cs_common_background_lable4dark": "#30303E",
  "cs_common_background_lablefour": "#F0F7FF",
  "cs_common_background_lablethree": "#FFE3E9",
  "cs_common_background_labletwo": "#FFEEF2",
  "cs_common_background_least": "#C6C6C6",
  "cs_common_background_lightgreydark": "#E6E6E6",
  "cs_common_background_line": "#F8F8F8",
  "cs_common_background_loading_secondary": "rgba(198,198,198,0.50)",
  "cs_common_background_main": "#FE3666",
  "cs_common_background_maindark": "#F73B68",
  "cs_common_background_mainlight": "#FE3666",
  "cs_common_background_masking": "rgba(0,0,0,0.30)",
  "cs_common_background_maskingdark": "rgba(0,0,0,0.30)",
  "cs_common_background_message": "#FFFFFF",
  "cs_common_background_navigation_primary": "#F8F8F8",
  "cs_common_background_normal_indicator": "rgba(255,255,255,0.50)",
  "cs_common_background_orange": "#FF4906",
  "cs_common_background_orange1": "#FF8048",
  "cs_common_background_placeholder": "#C6C6C6",
  "cs_common_background_placeholder_deep": "#9C9C9C",
  "cs_common_background_placeholder_deepdark": "#909092",
  "cs_common_background_placeholderdark": "#6B6B6F",
  "cs_common_background_primary": "#F8F8F8",
  "cs_common_background_primarydark": "#19191E",
  "cs_common_background_process_bg": "rgba(181,181,182,0.90)",
  "cs_common_background_red": "#FE3666",
  "cs_common_background_red_error": "#FA4E3E",
  "cs_common_background_reddark": "#FF4C4C",
  "cs_common_background_round_destructive": "rgba(254,54,102,0.80)",
  "cs_common_background_safetydark": "#618EFF",
  "cs_common_background_safetylight": "#326BFB",
  "cs_common_background_secondary": "#FFFFFF",
  "cs_common_background_selected_index": "#FF5000",
  "cs_common_background_seperator": "rgba(255,255,255,0.039)",
  "cs_common_background_shallowblack": "#222222",
  "cs_common_background_shallowblackdark": "#E6E6E6",
  "cs_common_background_shallowgray": "#E0E0E0",
  "cs_common_background_shallowgraydark": "#E0E0E0",
  "cs_common_background_surface_primary": "#FFFFFF",
  "cs_common_background_surface_primarydark": "#222226",
  "cs_common_background_surface_secondary": "#F0F0F0",
  "cs_common_background_switch": "#EAEAEA",
  "cs_common_background_switchdark": "#6B6B6F",
  "cs_common_background_tab": "rgba(255,255,255,0.0)",
  "cs_common_background_tertiary": "#FE3666",
  "cs_common_background_toast": "rgba(0,0,0,0.70)",
  "cs_common_background_toastdark": "#3D3D42",
  "cs_common_background_underline": "#EAEAEA",
  "cs_common_background_whitelight": "#FFFFFF",
  "cs_common_stroke_cccc": "#FE3666",
  "cs_common_stroke_clear": "rgba(0,0,0,0.0)",
  "cs_common_stroke_dialogline": "#EAEAEA",
  "cs_common_stroke_dialoglinedark": "#333337",
  "cs_common_stroke_green": "#17C5A2",
  "cs_common_stroke_indicator": "rgba(0,0,0,0.15)",
  "cs_common_stroke_link": "#385080",
  "cs_common_stroke_linkdark": "#667BA3",
  "cs_common_stroke_main": "#FE3666",
  "cs_common_stroke_maindark": "#F73B68",
  "cs_common_stroke_orange": "#FF8048",
  "cs_common_stroke_primary": "#EAEAEA",
  "cs_common_stroke_primary_2": "#F8F8F8",
  "cs_common_stroke_primary_2dark": "#19191E",
  "cs_common_stroke_primary_3": "#FF4906",
  "cs_common_stroke_primary_3dark": "#FF5814",
  "cs_common_stroke_primary_4": "#E0E0E0",
  "cs_common_stroke_primary_4dark": "#222226",
  "cs_common_stroke_primary_5": "#222222",
  "cs_common_stroke_primary_5dark": "#E6E6E6",
  "cs_common_stroke_primarydark": "#2B2B2F",
  "cs_common_stroke_red_error": "#FA4E3E",
  "cs_common_stroke_redadrk": "#FF4C4C",
  "cs_common_stroke_secondary": "#222222",
  "cs_common_stroke_secondary1": "#9C9C9C",
  "cs_common_stroke_secondary1dark": "#909092",
  "cs_common_stroke_secondary2": "#F0F0F0",
  "cs_common_stroke_secondary2dark": "#6B6B6F",
  "cs_common_stroke_secondary3": "#C6C6C6",
  "cs_common_stroke_secondary3dark": "#909092",
  "cs_common_stroke_selectcard": "#E0E0E0",
  "cs_common_stroke_seperator": "#EAEAEA",
  "cs_common_stroke_white": "#FFFFFF",
  "cs_common_text_black": "#000000",
  "cs_common_text_bubble": "#FFFFFF",
  "cs_common_text_bubbleprimary": "#222222",
  "cs_common_text_button": "#FFFFFF",
  "cs_common_text_clear": "rgba(0,0,0,0.0)",
  "cs_common_text_dialog_primary": "#222222",
  "cs_common_text_dialog_secondary": "#666666",
  "cs_common_text_dialog_text1": "#666666",
  "cs_common_text_dialog_text2": "#222222",
  "cs_common_text_dialog_text3": "#9C9C9C",
  "cs_common_text_green": "#17C5A2",
  "cs_common_text_hintsafety": "#326BFB",
  "cs_common_text_hintsafetydark": "#618EFF",
  "cs_common_text_least": "#C6C6C6",
  "cs_common_text_leastdark": "#6B6B6F",
  "cs_common_text_link": "#385080",
  "cs_common_text_linkdark": "#385080",
  "cs_common_text_linkpress": "rgba(56,80,128,0.50)",
  "cs_common_text_linkpressdark": "rgba(102,123,163,0.50)",
  "cs_common_text_main": "#FE3666",
  "cs_common_text_mainbutton": "#FFFFFF",
  "cs_common_text_mainbuttondark": "#FFFFFF",
  "cs_common_text_maindark": "#F73B68",
  "cs_common_text_mainlight": "#FE3666",
  "cs_common_text_orange": "#FF4906",
  "cs_common_text_orange1": "#FF8048",
  "cs_common_text_primary": "#666666",
  "cs_common_text_primarydark": "#B5B5B6",
  "cs_common_text_red": "#FE3666",
  "cs_common_text_red_error": "#FA4E3E",
  "cs_common_text_reddark": "#F73B68",
  "cs_common_text_secondary": "#9C9C9C",
  "cs_common_text_secondarydark": "#909092",
  "cs_common_text_shallowblack": "#222222",
  "cs_common_text_shallowdark": "#2B2B2F",
  "cs_common_text_shallowgrey": "#EAEAEA",
  "cs_common_text_shallowwhite": "#EAEAEA",
  "cs_common_text_tab_normal": "rgba(255,255,255,0.50)",
  "cs_common_text_title": "#222222",
  "cs_common_text_titledark": "#E6E6E6",
  "cs_common_text_white": "#FFFFFF",
  "cs_common_text_whitedark": "#222226",
  "cs_common_text_whitelight": "#FFFFFF",
  "cs_common_tint_allblack": "#000000",
  "cs_common_tint_black": "#222222",
  "cs_common_tint_blackdark": "#E6E6E6",
  "cs_common_tint_blue": "#326BFB",
  "cs_common_tint_bluedark": "#618EFF",
  "cs_common_tint_darkgrey": "#666666",
  "cs_common_tint_darkgreydark": "#B5B5B6",
  "cs_common_tint_green": "#17C5A2",
  "cs_common_tint_grey": "#9C9C9C",
  "cs_common_tint_greydark": "#909092",
  "cs_common_tint_hintsafety": "#326BFB",
  "cs_common_tint_lightgrey": "#C6C6C6",
  "cs_common_tint_lightgreydark": "#6B6B6F",
  "cs_common_tint_link": "#385080",
  "cs_common_tint_linkdark": "#667BA3",
  "cs_common_tint_main": "#FE3666",
  "cs_common_tint_maindark": "#F73B68",
  "cs_common_tint_orange": "#FF4906",
  "cs_common_tint_orange1": "#FF8048",
  "cs_common_tint_red": "#FE3666",
  "cs_common_tint_red_error": "#FA4E3E",
  "cs_common_tint_reddark": "#F73B68",
  "cs_common_tint_searchicon": "rgba(0,0,0,0.20)",
  "cs_common_tint_vajrablue": "#779EFE",
  "cs_common_tint_vajragreen": "#76D679",
  "cs_common_tint_vajraorange": "#FFA061",
  "cs_common_tint_vajrared": "#FF6B80",
  "cs_common_tint_vajraviolet": "#A189FE",
  "cs_common_tint_white": "#FFFFFF",
  "cs_common_tint_whitedark": "#FFFFFF"
}

export const colorSceneDark = {
  "cs_common_background__divider_primarydark": "#222226",
  "cs_common_background__divider_secondarydark": "#2B2B2F",
  "cs_common_background__navigation_primary": "#222226",
  "cs_common_background_action_selected": "rgba(255,255,255,0.039)",
  "cs_common_background_alert_seperator": "rgba(255,255,255,0.078)",
  "cs_common_background_alet_list_seperator": "rgba(34,34,38,0.039)",
  "cs_common_background_badge": "#F86286",
  "cs_common_background_black": "#E6E6E6",
  "cs_common_background_bubble": "#FFFFFF",
  "cs_common_background_bubble_primary": "rgba(0,0,0,0.70)",
  "cs_common_background_bubble_shadow": "#000000",
  "cs_common_background_butpress": "rgba(247,59,104,0.50)",
  "cs_common_background_clear": "rgba(0,0,0,0.0)",
  "cs_common_background_dialog": "#2B2B2F",
  "cs_common_background_dialog_primary": "#B5B5B6",
  "cs_common_background_dialog_secondary": "#E6E6E6",
  "cs_common_background_divider_primary": "#222226",
  "cs_common_background_divider_secondary": "#2B2B2F",
  "cs_common_background_float_primary": "#2B2B2F",
  "cs_common_background_float_primarydark": "#2B2B2F",
  "cs_common_background_gradient_start": "#FF4906",
  "cs_common_background_gravitybtn": "#F86850",
  "cs_common_background_gray": "#B5B5B6",
  "cs_common_background_graydark": "#B5B5B6",
  "cs_common_background_green": "#2DC5A6",
  "cs_common_background_hintsafety": "#618EFF",
  "cs_common_background_label_bg2": "#190908",
  "cs_common_background_label1dark": "#2B2B2F",
  "cs_common_background_labelbackgroundcolor": "#3B2824",
  "cs_common_background_labelbackgroundcolordark": "#3B2824",
  "cs_common_background_labelone": "#2B2B2F",
  "cs_common_background_lable2dark": "#351F28",
  "cs_common_background_lable4dark": "#30303E",
  "cs_common_background_lablefour": "#050B19",
  "cs_common_background_lablethree": "#351F28",
  "cs_common_background_labletwo": "#351F28",
  "cs_common_background_least": "#C6C6C6",
  "cs_common_background_lightgreydark": "#E6E6E6",
  "cs_common_background_line": "rgba(255,255,255,0.078)",
  "cs_common_background_loading_secondary": "rgba(198,198,198,0.50)",
  "cs_common_background_main": "#F73B68",
  "cs_common_background_maindark": "#F73B68",
  "cs_common_background_mainlight": "#FE3666",
  "cs_common_background_masking": "rgba(0,0,0,0.30)",
  "cs_common_background_maskingdark": "rgba(0,0,0,0.30)",
  "cs_common_background_message": "#E6E6E6",
  "cs_common_background_navigation_primary": "#222226",
  "cs_common_background_normal_indicator": "rgba(34,34,38,0.50)",
  "cs_common_background_orange": "#FF5814",
  "cs_common_background_orange1": "#FF8652",
  "cs_common_background_placeholder": "#6B6B6F",
  "cs_common_background_placeholder_deep": "#909092",
  "cs_common_background_placeholder_deepdark": "#909092",
  "cs_common_background_placeholderdark": "#6B6B6F",
  "cs_common_background_primary": "#19191E",
  "cs_common_background_primarydark": "#19191E",
  "cs_common_background_process_bg": "rgba(255,255,255,0.90)",
  "cs_common_background_red": "#F73B68",
  "cs_common_background_red_error": "#FF5D52",
  "cs_common_background_reddark": "#FF4C4C",
  "cs_common_background_round_destructive": "rgba(247,59,104,0.80)",
  "cs_common_background_safetydark": "#618EFF",
  "cs_common_background_safetylight": "#326BFB",
  "cs_common_background_secondary": "#19191E",
  "cs_common_background_selected_index": "#FF5F14",
  "cs_common_background_seperator": "rgba(0,0,0,0.039)",
  "cs_common_background_shallowblack": "#E6E6E6",
  "cs_common_background_shallowblackdark": "#E6E6E6",
  "cs_common_background_shallowgray": "#E0E0E0",
  "cs_common_background_shallowgraydark": "#E0E0E0",
  "cs_common_background_surface_primary": "#222226",
  "cs_common_background_surface_primarydark": "#222226",
  "cs_common_background_surface_secondary": "#222226",
  "cs_common_background_switch": "#6B6B6F",
  "cs_common_background_switchdark": "#6B6B6F",
  "cs_common_background_tab": "rgba(255,255,255,0.0)",
  "cs_common_background_tertiary": "#FE3666",
  "cs_common_background_toast": "#3D3D42",
  "cs_common_background_toastdark": "#3D3D42",
  "cs_common_background_underline": "#222226",
  "cs_common_background_whitelight": "#FFFFFF",
  "cs_common_stroke_cccc": "#F73B68",
  "cs_common_stroke_clear": "rgba(0,0,0,0.0)",
  "cs_common_stroke_dialogline": "#333337",
  "cs_common_stroke_dialoglinedark": "#333337",
  "cs_common_stroke_green": "#2DC5A6",
  "cs_common_stroke_indicator": "rgba(255,255,255,0.10)",
  "cs_common_stroke_link": "#667BA3",
  "cs_common_stroke_linkdark": "#667BA3",
  "cs_common_stroke_main": "#F73B68",
  "cs_common_stroke_maindark": "#F73B68",
  "cs_common_stroke_orange": "#FF8652",
  "cs_common_stroke_primary": "#2B2B2F",
  "cs_common_stroke_primary_2": "#19191E",
  "cs_common_stroke_primary_2dark": "#19191E",
  "cs_common_stroke_primary_3": "#FF5814",
  "cs_common_stroke_primary_3dark": "#FF5814",
  "cs_common_stroke_primary_4": "#222226",
  "cs_common_stroke_primary_4dark": "#222226",
  "cs_common_stroke_primary_5": "#E6E6E6",
  "cs_common_stroke_primary_5dark": "#E6E6E6",
  "cs_common_stroke_primarydark": "#2B2B2F",
  "cs_common_stroke_red_error": "#FF5D52",
  "cs_common_stroke_redadrk": "#FF4C4C",
  "cs_common_stroke_secondary": "#E6E6E6",
  "cs_common_stroke_secondary1": "#909092",
  "cs_common_stroke_secondary1dark": "#909092",
  "cs_common_stroke_secondary2": "#6B6B6F",
  "cs_common_stroke_secondary2dark": "#6B6B6F",
  "cs_common_stroke_secondary3": "#909092",
  "cs_common_stroke_secondary3dark": "#909092",
  "cs_common_stroke_selectcard": "#3D3D42",
  "cs_common_stroke_seperator": "rgba(255,255,255,0.30)",
  "cs_common_stroke_white": "#FFFFFF",
  "cs_common_text_black": "#E6E6E6",
  "cs_common_text_bubble": "#222222",
  "cs_common_text_bubbleprimary": "#222222",
  "cs_common_text_button": "#E6E6E6",
  "cs_common_text_clear": "rgba(0,0,0,0.0)",
  "cs_common_text_dialog_primary": "#B5B5B6",
  "cs_common_text_dialog_secondary": "#E6E6E6",
  "cs_common_text_dialog_text1": "#E6E6E6",
  "cs_common_text_dialog_text2": "#B5B5B6",
  "cs_common_text_dialog_text3": "#B5B5B6",
  "cs_common_text_green": "#2DC5A6",
  "cs_common_text_hintsafety": "#618EFF",
  "cs_common_text_hintsafetydark": "#618EFF",
  "cs_common_text_least": "#6B6B6F",
  "cs_common_text_leastdark": "#6B6B6F",
  "cs_common_text_link": "#667BA3",
  "cs_common_text_linkdark": "#385080",
  "cs_common_text_linkpress": "rgba(102,123,163,0.50)",
  "cs_common_text_linkpressdark": "rgba(102,123,163,0.50)",
  "cs_common_text_main": "#F73B68",
  "cs_common_text_mainbutton": "#FFFFFF",
  "cs_common_text_mainbuttondark": "#FFFFFF",
  "cs_common_text_maindark": "#F73B68",
  "cs_common_text_mainlight": "#FE3666",
  "cs_common_text_orange": "#FF5814",
  "cs_common_text_orange1": "#FF8652",
  "cs_common_text_primary": "#B5B5B6",
  "cs_common_text_primarydark": "#B5B5B6",
  "cs_common_text_red": "#F73B68",
  "cs_common_text_red_error": "#FF5D52",
  "cs_common_text_reddark": "#F73B68",
  "cs_common_text_secondary": "#909092",
  "cs_common_text_secondarydark": "#909092",
  "cs_common_text_shallowblack": "#E6E6E6",
  "cs_common_text_shallowdark": "#2B2B2F",
  "cs_common_text_shallowgrey": "#2B2B2F",
  "cs_common_text_shallowwhite": "#2B2B2F",
  "cs_common_text_tab_normal": "rgba(255,255,255,0.50)",
  "cs_common_text_title": "#E6E6E6",
  "cs_common_text_titledark": "#E6E6E6",
  "cs_common_text_white": "#222226",
  "cs_common_text_whitedark": "#222226",
  "cs_common_text_whitelight": "#FFFFFF",
  "cs_common_tint_allblack": "#E6E6E6",
  "cs_common_tint_black": "#E6E6E6",
  "cs_common_tint_blackdark": "#E6E6E6",
  "cs_common_tint_blue": "#618EFF",
  "cs_common_tint_bluedark": "#618EFF",
  "cs_common_tint_darkgrey": "#B5B5B6",
  "cs_common_tint_darkgreydark": "#B5B5B6",
  "cs_common_tint_green": "#2DC5A6",
  "cs_common_tint_grey": "#909092",
  "cs_common_tint_greydark": "#909092",
  "cs_common_tint_hintsafety": "#618EFF",
  "cs_common_tint_lightgrey": "#6B6B6F",
  "cs_common_tint_lightgreydark": "#6B6B6F",
  "cs_common_tint_link": "#667BA3",
  "cs_common_tint_linkdark": "#667BA3",
  "cs_common_tint_main": "#F73B68",
  "cs_common_tint_maindark": "#F73B68",
  "cs_common_tint_orange": "#FF5814",
  "cs_common_tint_orange1": "#FF8652",
  "cs_common_tint_red": "#F73B68",
  "cs_common_tint_red_error": "#FF5D52",
  "cs_common_tint_reddark": "#F73B68",
  "cs_common_tint_searchicon": "rgba(230,230,230,0.20)",
  "cs_common_tint_vajrablue": "#5F82D9",
  "cs_common_tint_vajragreen": "#64B566",
  "cs_common_tint_vajraorange": "#DB8B56",
  "cs_common_tint_vajrared": "#E56577",
  "cs_common_tint_vajraviolet": "#8873D9",
  "cs_common_tint_white": "#FFFFFF",
  "cs_common_tint_whitedark": "#FFFFFF"
}
